/* =====================================================================
 * WorkspaceRouter — legacy active-route content bridge.
 *
 * Route-first hosts mount concrete route layout elements directly. This
 * component stays as the compatibility bridge for WorkspaceModeShell.
 * ===================================================================== */

import React from 'react';
import { WorkspaceModeContent } from './WorkspaceModeContent';

interface WorkspaceRouterProps {
  inputSlot?: React.ReactNode;
}

export const WorkspaceRouter: React.FC<WorkspaceRouterProps> = ({ inputSlot }) => (
  <WorkspaceModeContent inputSlot={inputSlot} />
);
